var React = require('react');

function ArrowUpRight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6.33398 14.2786L14.6673 5.94531","stroke":"white","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M6.33398 5.94531H14.6673V14.2786","stroke":"white","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ArrowUpRight.defaultProps = {"width":"21","height":"20","viewBox":"0 0 21 20","fill":"none"};

module.exports = ArrowUpRight;

ArrowUpRight.default = ArrowUpRight;
